// File: components/CoreTeamSalaries.js
import React from 'react';
import SalarySelector from './SalarySelector';

const CoreTeamSalaries = ({
  tristenSalaryTier,
  setTristenSalaryTier,
  martinSalaryTier,
  setMartinSalaryTier,
  salaryTiers,
  getTristenSalaryDescription,
  eaType,
  formatCurrency,
  coreTeamInfo,
  salarySelectorConfig,
  location,
  applyLocationMultiplier,
  summaryBoxInfo
}) => {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold mb-2">{coreTeamInfo.title}</h2>

      {/* Tristen's Salary */}
      <SalarySelector
        label={coreTeamInfo.tristenInfo.title}
        selectedTier={tristenSalaryTier}
        setSelectedTier={setTristenSalaryTier}
        salaryTiers={salaryTiers}
        getCustomDescription={getTristenSalaryDescription}
        isEaAdjusted={true}
        eaType={eaType}
        additionalInfo={coreTeamInfo && coreTeamInfo.tristenInfo ? coreTeamInfo.tristenInfo.description : null}
        selectorConfig={salarySelectorConfig}
        location={location}
        applyLocationMultiplier={applyLocationMultiplier}
        summaryBoxInfo={summaryBoxInfo}
      />

      {/* Martin's Salary */}
      <SalarySelector
        label={coreTeamInfo.martinInfo.title}
        selectedTier={martinSalaryTier}
        setSelectedTier={setMartinSalaryTier}
        salaryTiers={salaryTiers}
        additionalInfo={coreTeamInfo && coreTeamInfo.martinInfo ? coreTeamInfo.martinInfo.description : null}
        selectorConfig={salarySelectorConfig}
        location={location}
        applyLocationMultiplier={applyLocationMultiplier}
        summaryBoxInfo={summaryBoxInfo}
      />
    </div>
  );
};

export default CoreTeamSalaries;